// Minimal HTML sanitizer for admin-authored rich text (defense-in-depth).
// Removes dangerous elements/attributes before rendering with dangerouslySetInnerHTML.
export function sanitizeHtml(html) {
  if (!html || typeof html !== "string") return "";
  if (typeof window === "undefined" || !window.DOMParser) return html;
  try {
    const doc = new window.DOMParser().parseFromString(html, "text/html");
    const BAD = new Set(["script", "style", "iframe", "object", "embed", "link", "meta", "form", "input"]);
    const walk = (node) => {
      for (const el of Array.from(node.children || [])) {
        const tag = el.tagName.toLowerCase();
        if (BAD.has(tag)) { el.remove(); continue; }
        for (const attr of Array.from(el.attributes)) {
          const name = attr.name.toLowerCase();
          const val = (attr.value || "").trim().toLowerCase();
          if (name.startsWith("on")) el.removeAttribute(attr.name);
          if ((name === "href" || name === "src") && val.startsWith("javascript:")) el.removeAttribute(attr.name);
        }
        walk(el);
      }
    };
    walk(doc.body);
    return doc.body.innerHTML;
  } catch {
    return html;
  }
}
